import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';

export default function RemoveButton(props){
  return <RemoveCircleOutlineIcon {...props}/>;
}
